import { MatrixClient, NotificationCountType } from 'matrix-js-sdk/src/matrix';

import { getAllMessengerRooms } from 'modules/Messenger/components/ConversationsList/utils';
import logger from 'utils/logging/faro';

export async function clearMessengerUnreadAfterEncryptionReset(matrixClient: MatrixClient): Promise<void> {
  const rooms = getAllMessengerRooms(matrixClient);

  const roomsWithUnread = rooms.filter(
    (room) =>
      (room.getRoomUnreadNotificationCount(NotificationCountType.Total) ?? 0) > 0 ||
      (room.getRoomUnreadNotificationCount(NotificationCountType.Highlight) ?? 0) > 0 ||
      room.getAccountData('m.marked_unread')?.getContent()?.unread === true
  );

  for (const room of roomsWithUnread) {
    room.setUnreadNotificationCount(NotificationCountType.Total, 0);
    room.setUnreadNotificationCount(NotificationCountType.Highlight, 0);
  }

  await Promise.allSettled(
    roomsWithUnread
      .filter((room) => room.getAccountData('m.marked_unread')?.getContent()?.unread === true)
      .map((room) =>
        matrixClient
          .setRoomAccountData(room.roomId, 'm.marked_unread', { unread: false })
          .catch((err) =>
            logger.error('Failed to clear m.marked_unread after encryption reset', { roomId: room.roomId, err })
          )
      )
  );
}
